import React from 'react';
import PropTypes from 'prop-types';
import { Button } from "@mui/material";
import { Delete } from "@mui/icons-material";
import ModalShell from "../../ModalShell";
import ResponseModal from "../../ResponseModal";

export default function InlineEditModal({
  isError,
  responseModal,
  setResponseModal,
  responseBreakdown,
  confirmDelete,
  setConfirmDelete,
  activeWindow,
  typeDisplayObj,
  displayKey,
  displayValue,
  onDelete,
  onClose,
  onNewClose,
  loading,
  title
}) {
  return (
    <>
      <ResponseModal
        title={`${isError ? "Failed" : "Successful"}`}
        isError={isError}
        description={isError ? "" : responseBreakdown}
        openBool={responseModal}
        setOpenBool={setResponseModal}
        errorMessage={responseBreakdown}
        handleCloseFunc={!activeWindow ? onNewClose : onClose}
      />
      {activeWindow && (
        <ModalShell
          open={confirmDelete}
          setOpen={setConfirmDelete}
          color={"red"}
          title={`Confirm ${title} removal`}
        >
          <div>
            <p className="text-center">
              Are you sure you want to remove this {title}?
            </p>
            <p className="text-center font-bold">
              <span className="font-bold">
                {typeDisplayObj ? typeDisplayObj[activeWindow[displayKey]] : activeWindow[displayKey]}
              </span>
              : {activeWindow[displayValue]}
            </p>
            <div className="w-fit mx-auto my-2">
              <Button
                onClick={onDelete}
                endIcon={<Delete />}
                variant="outlined"
                className="text-red-600 border-red-600"
                disabled={loading}
              >
                Confirm Delete
              </Button>
            </div>
          </div>
        </ModalShell>
      )}
    </>
  );
}

InlineEditModal.propTypes = {
  isError: PropTypes.bool.isRequired,
  responseModal: PropTypes.bool.isRequired,
  setResponseModal: PropTypes.func.isRequired,
  responseBreakdown: PropTypes.string.isRequired,
  confirmDelete: PropTypes.bool.isRequired,
  setConfirmDelete: PropTypes.func.isRequired,
  activeWindow: PropTypes.shape({
    id: PropTypes.number,
    email_type: PropTypes.string,
    email: PropTypes.string,
    contact_label: PropTypes.string,
    display: PropTypes.string
  }),
  typeDisplayObj: PropTypes.object,
  displayKey: PropTypes.string.isRequired,
  displayValue: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onNewClose: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired
};

InlineEditModal.defaultProps = {
  activeWindow: null,
  typeDisplayObj: null
}; 